module.exports = __webpack_public_path__ + "static/2-5952cfcc18d80c25b951e35f97c7b0e8.png";